import { Link } from "react-router-dom";
import { authScreens } from "@jkast90/kast-common/ui";
import { signIn, signOut } from "@common/auth/session";

/**
 * The gates' screens: loading, the sign-in prompt a signed-out visitor sees in
 * place of content that needs an account (never a data-shaped empty state),
 * and the admin page's refusal.
 */
export const screens = authScreens({
  signIn: {
    onSignIn: signIn,
    detail: "Sign in with your kast-dev account to see this.",
    signInLabel: "Sign in",
    headingLevel: 2,
  },
  notAllowed: {
    title: "This page is for Salvagers admins",
    detail: "If you were just made one, sign out and back in so your sign-in picks it up.",
    homeHref: "/",
    onSwitchAccount: () => void signOut(),
    headingLevel: 2,
    renderLink: (link) => (
      <Link to={link.href} className={link.className}>
        {link.label}
      </Link>
    ),
  },
});
